import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toggleFilter } from "../../features/filter/filterSlice";

const Sidebar = () => {
    const dispatch = useDispatch()
  return (
    <div className="sidebar">
      <nav>
        <ul className="space-y-4">
          <li>
            <Link to="/" className="main-menu menu-active" id="lws-alljobs-menu" onClick={() => dispatch(toggleFilter(''))}>
              <i className="fa-solid fa-briefcase"></i>
              <span> All Available Jobs</span>
            </Link>
            <ul className="space-y-6 lg:space-y-2 ">
              <li>
                <Link
                  to="/"
                  className="sub-menu"
                  id="lws-internship-menu"
                  onClick={() => dispatch(toggleFilter('Internship'))}
                >
                  <i className="fa-solid fa-stop !text-[#FF5757]"></i>
                  Internship
                </Link>
              </li>
              <li>
                <Link
                  className="sub-menu"
                  to={'/'}
                  id="lws-fulltime-menu"
                  onClick={() => dispatch(toggleFilter('Full Time'))}
                >
                  <i className="fa-solid fa-stop !text-[#FF8A00]"></i>
                  Full Time
                </Link>
              </li>
              <li>
                <Link className="sub-menu" to={'/'} id="lws-remote-menu" onClick={() => dispatch(toggleFilter('Remote'))}>
                  <i className="fa-solid fa-stop !text-[#56E5C4]"></i>
                  Remote
                </Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/form" className="main-menu" id="lws-addJob-menu">
              <i className="fa-solid fa-file-circle-plus"></i>
              <span>Add NewJob</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
